import { graphql } from "@/gql";

export const PLAN_QUERY = graphql(`
  query PLAN_QUERY($id: String!) {
    plan(id: $id) {
      id
      name
      isExternalBilling
      featureRapidsos
      marketingType
      description
      featureList
      stripeProductId
      stripeMonthPriceId
      stripeMonthPrice {
        id
        unitAmount
        unitAmountDecimal
      }
      stripeYearPriceId
      stripeYearPrice {
        id
        unitAmount
        unitAmountDecimal
      }
      createdAt
      updatedAt
      organizations {
        edges {
          node {
            id
            name
            logoUrl
            state
            memberCount
          }
        }
      }
    }
  }
`);
